import React from 'react';
import { DatabaseIcon, PhoneOffIcon, ShuffleIcon } from 'lucide-react';
import { costCards, leakCards } from '../data/content';
import { Reveal } from './showcase/Reveal';
const leakIcons = {
  missed: PhoneOffIcon,
  database: DatabaseIcon,
  chaos: ShuffleIcon
};
export function LeakSection() {
  return <section id="leak" aria-labelledby="leak-title" className="border-b border-white/5 bg-ink-800" data-id="element-141" data-mp="3b1snglkt32f5">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-142" data-mp="2nczvt1b7vgqc">
        <Reveal data-id="element-143" data-mp="2ie50izw2bzpc">
          <h2 id="leak-title" className="max-w-2xl font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-144" data-mp="2ieok0l1d2w5h">
            The leak this actually fixes.
          </h2>
          <p className="mt-4 max-w-xl text-sm text-white/55" data-id="element-145" data-mp="2rg5wzujh2hpy">
            What you pay per lead, and where those leads go to die.
          </p>
        </Reveal>

        <dl className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-146" data-mp="6n150k8nnwyh">
          {costCards.map((card, index) => <div key={card.source} className="h-full" data-id="element-147" data-mp="1e27jd1q9x22q" data-mpi={index}>
              <Reveal delay={0.05 * index} className="h-full" data-id="element-148" data-mp="1i4autqcy06o0">
                <div className="h-full rounded-xl border border-white/10 bg-ink-700 p-6" data-id="element-149" data-mp="1i2rha7io89px">
                  <dt className="font-display text-base font-semibold tracking-tight text-brand" data-id="element-150" data-mp="1n473w40hyoaf">
                    {card.source}
                  </dt>
                  <dd className="mt-3 text-sm leading-relaxed text-white/55" data-id="element-151" data-mp="ufi72h6h554h">
                    {card.body}
                  </dd>
                </div>
              </Reveal>
            </div>)}
        </dl>

        <dl className="mt-4 grid gap-4 md:grid-cols-3" data-id="element-152" data-mp="14c4qd1j5jo4e">
          {leakCards.map((card, index) => {
          const Icon = leakIcons[card.icon];
          return <div key={card.title} className="h-full" data-id="element-153" data-mp="bos1ultfl68g" data-mpi={index}>
                <Reveal delay={0.05 * index} className="h-full" data-id="element-154" data-mp="bo8mncv60vy4">
                  <div className="h-full rounded-xl border border-white/10 bg-ink-700 p-6" data-id="element-155" data-mp="gmjw3mhjt4ft">
                    <span className="flex h-9 w-9 items-center justify-center rounded-lg border border-brand/30 bg-brand/10" data-id="element-156" data-mp="8m43h4xxarrq">
                      <Icon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-157" data-mp="4ksm1mp7dcum" />
                    </span>
                    <dt className="mt-4 font-display text-base font-semibold tracking-tight text-white" data-id="element-158" data-mp="ibxfu85w3ax1">
                      {card.title}
                    </dt>
                    <dd className="mt-2 text-sm leading-relaxed text-white/55" data-id="element-159" data-mp="3lsnsh5vz8m7p">
                      {card.body}
                    </dd>
                  </div>
                </Reveal>
              </div>;
        })}
        </dl>
      </div>
    </section>;
}